/**
 * Returns the asset path for the role-badge icon based on aliasOrg / type string.
 * Usage: getOrgTypeIcon(aliasOrg)
 */
export function getOrgTypeIcon(aliasOrg: string): string {
    const map: Record<string, string> = {
        'food producer': 'assets/img/layout/food-producer-icon.svg',
        'exporter': 'assets/img/layout/exporters.svg',
        'exporters': 'assets/img/layout/exporters.svg',
        'importer': 'assets/img/layout/importers.svg',
        'importers': 'assets/img/layout/importers.svg',
        'food processor': 'assets/img/layout/food-processors.svg',
        'food processors': 'assets/img/layout/food-processors.svg',
    };

    const key = (aliasOrg ?? '').toLowerCase().trim();
    return map[key] ?? 'assets/img/layout/food-producer-icon.svg';
}
